import Molde from "./MoldeTourTradicionalTrek";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function LagunaHuamantay() {
  return (
    <>
      <Molde
        image={"/images/img-slide-desktop-laguna.png"}
        title={"LAGUNA HUAMANTAY"}
        subtitle={"(FULL DAY)"}
        description={
          "A partir de las 4:30 am pasaremos a recoger a su respectivo hostal o hotel ubicado en Cusco, para luego continuar con nuestro viaje en nuestro trasporte privado y conducirnos al poblado de Mollepata en el exuberante valle del río Apurimac, lugar donde degustaremos de nuestro desayuno y compraremos lo que se necesite para realizar el recorrido antes de iniciar la caminata a la Laguna Humantay ubicado a 4200 m.s.n.m. Luego del desayuno, seguimos hacia Challacancha disfrutando durante el recorrido de toda la majestuosidad del nevado Humantay en la cordillera de Vilcabamba y continuamos la ruta con destino a Soraypampa 2900 msnm, lugar donde tendremos un pequeño descanso, cargándonos de energía para continuar nuestro viaje hasta el punto de inicio de la caminata de Soraypampa, iniciando nuestra caminata con vistas impresionantes de la Laguna Humantay y sorprendentes miradores apreciando toda la belleza paisajística. De Soraypampa a la Laguna Humantay son 7 km, que se puede hacer entre 1 hora con 30 minutos a 2 horas de caminata aproximadamente. Podremos apreciar por un lado el Humantay a 4200 m.s.n.m y por el otro lado el Imponente Nevado de Salkantay, luego retornaremos a nuestro campamento para nuestro almuerzo y tiempo libre para tomar fotos, descansar y finalmente estaremos retornando de Soraypampa con destino a la ciudad de Cusco"
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 45.00"}
        moneda={"DOLARES"}*/
        mapa={
          <>
            <div>
              <h1 className="text-primary-800 font-bold">UBICACIÓN</h1>
            </div>
            <img className="rounded-lg border-primary-800 border-2" src={`${process.env.PUBLIC_URL}/images/mapa_huamantay.png`} alt="" />
          </>
        }
        galeria={
            <>
              
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/laguna_1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/laguna_2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/laguna_3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/laguna_4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/laguna_5.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/laguna_6.png`} alt="" />
            </>
          }
        incluye={
          <>
            <li>Recojo en hotel</li>
            <li>Transporte turistico</li>
          
            <li>Asistencia permanente</li>
            <li>Desayuno</li>
            <li>Almuerzo</li>
            <li>Botiquin</li>
          </>
        }
        noIncluye={
          <>
            <li>Ingreso a la laguna</li>
            <li>Gastos extra</li>
            <li>Alquiler de caballo</li>
          </>
        }
        recomendaciones={
          <>
            <li>Bloqueador solar.</li>
            <li>Poncho en caso de lluvia.</li>
            <li>Gorra, sombrero, guantes, lentes de sol.</li>
            <li>Botella con agua.</li>
            <li>Cortavientos, pantalón de trekking.</li>
            <li>Zapatillas ideales para trekking.</li>
            <li>Snacks, cámara fotográfica, documentos, dinero extra.</li>
          </>
        }
        caracteristica={
            <>
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
                title={"Dificultad"}
                desc={"Alta"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                title={"Tipo Servicio"}
                desc={"Compartido"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                title={"Duración"}
                desc={"Full day"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                title={"Tipo de Tour"}
                desc={"trek"}
              />
            </>
          }

        lugarvisita={
          <>
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Mollepata"}
            />
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Soraypampa"}
            />
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Salkantay"}
            />
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Humantay"}
            />
          </>
        }
        TourRecomienda={
          <>
            <CardRecomienda
              img={"/images/montania_colores.png"}
              title={"MONTAÑA 7 COLORES"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/montania-colores'}
            />
            <CardRecomienda
              img={"/images/valle-vip-5.png"}
              title={"VALLE VIP"}
              puntuacion={"5"}
              link={'/tour-tradicional/valle-vip'}
            />
            <CardRecomienda
              img={"/images/cris-1.png"}
              title={"CITY TOUR"}
              puntuacion={"5"}
              link={'/tour-tradicional/citytour'}
            />
            <CardRecomienda
              img={"/images/maras-moray-4.png"}
              title={"MARAS-MORAY"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/maras-moray'}
            />
          </>
        }
      />
    </>
  );
}
